import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputComponent from '../../components/InputMC';
import RangeInputMC from '../../components/RangeInputMC';
import ToggleSwitchMC from '../../components/ToggleSwitchMC';
import TitleDescriptionMC from '../../components/TitleDescriptionMC';

const ManageFunnelStepOpened = () => {
  const {
    getValues,
    setValue,
  } = useFormContext();

  const isNew = !getValues('id');
  const { t } = useTranslation('Funnels');

  return (
    <div className="tw-wrapper">
      {!isNew && (
        <p className="tw-text-xs tw-pb-7">{t('sidebar.createFromZero.stageOpen.description')}</p>
      )}
      <InputComponent
        name="title"
        label={t('sidebar.createFromZero.stageOpen.fields.name.inputLabel')}
        placeholder={t('sidebar.createFromZero.stageOpen.fields.name.placeholder')}
        className="tw-resize-none"
        useFloatingLabel
      />
      <TitleDescriptionMC
        title={t('sidebar.createFromZero.stageOpen.fields.probability.title')}
        description={t('sidebar.createFromZero.stageOpen.fields.probability.subtitle')}
        className="tw-mt-4"
      />
      <RangeInputMC
        value={getValues('probability')}
        min={0}
        max={100}
        className="tw-mt-4 tw-w-96 tw-mb-6"
        onChange={({ target }) => setValue('probability', target.value, { shouldDirty: true, shouldValidate: true })}
      />
      <ToggleSwitchMC
        isOn={getValues('stagnation_time') !== null}
        handleToggle={() => setValue('stagnation_time', getValues('stagnation_time') === null ? 0 : null, { shouldDirty: true, shouldValidate: true })}
        label={t('sidebar.createFromZero.stageOpen.fields.stagnationTime.label')}
        labelClassName="!tw-text-base !tw-font-semibold tw-font-sans"
      />
      <p className="tw-text-xs tw-pb-2">
        {t('sidebar.createFromZero.stageOpen.fields.stagnationTime.description')}
      </p>

      {getValues('stagnation_time') !== null && (
        <InputComponent
          name="stagnation_time"
          type="number"
          label={t('sidebar.createFromZero.stageOpen.fields.stagnationTime.inputLabel')}
          placeholder={t('sidebar.createFromZero.stageOpen.fields.stagnationTime.placeholder')}
          className="tw-resize-none"
          useFloatingLabel
        />
      )}
    </div>
  );
};

export default ManageFunnelStepOpened;
